import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-timesheets',
  templateUrl: './employee-timesheets.component.html'
})
export class EmployeeTimesheetsComponent implements OnInit {

	employeeNames : Array<String>=[];
  constructor() { }

  ngOnInit() {
  	this.getNames();
  }

  getNames(){
  	this.employeeNames=['Shan Chathusanda','Isuru Sathyajith'];
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/time/components/employee-timesheets/employee-timesheets.component.ts